import React, {Component} from 'react';
import {Modal, Button, Header, Input, Icon} from 'semantic-ui-react';

export default class GuestPlayerModal extends Component {

    state = {
        modalOpen: false,
        sending: false,
        name: ''
    };

    handleOpen = () => this.setState({modalOpen: true});

    handleClose = () => this.setState({modalOpen: false});

    handleOk = () => {
        this.setState({sending: true});
        this.props.postEvent({
            type: "ADD_GUEST_PARTICIPANT",
            cageTrainingId: this.props.trainingId,
            playerName: this.state.name
        })
            .then(() => this.setState({sending: false}))
            .then(() => this.setState({modalOpen: false}));
    };

    handleNameChange = (ev) => {
        this.setState({name: ev.target.value});
    };

    render() {
        return (
            <Modal
                trigger={
                    <Button
                        size="tiny"
                        color='green'
                        basic
                        onClick={this.handleOpen}
                    >
                        Legg til
                    </Button>
                }
                open={this.state.modalOpen}
                onClose={this.handleClose}
                size='mini'
            >
                <Header icon='user plus' content='Legg til gjestespiller'/>
                <Modal.Content>
                    <Input placeholder='Navn' onChange={this.handleNameChange}/>
                </Modal.Content>
                <Modal.Actions>
                    <Button color='red' onClick={this.handleClose} inverted>
                        <Icon name='remove'/>Avbryt
                    </Button>
                    <Button positive loading={this.state.sending} onClick={this.handleOk} inverted>
                        <Icon name='checkmark'/>Legg til
                    </Button>
                </Modal.Actions>
            </Modal>);
    }
}


// WEBPACK FOOTER //
// ./src/Components/GuestPlayerModal.js